import { Link } from 'react-router-dom';
import { ScrollReveal } from '@/components/ui/scroll-reveal';

export function CTA() {
  const handleQuoteClick = () => {
    window.dispatchEvent(new CustomEvent('openContactForm'));
  };

  return (
    <section className="relative py-32 lg:py-40 overflow-hidden clip-diag-both">
      <img
        src="/images/heroes/hero-7-twilight-lobby.webp"
        alt=""
        className="absolute inset-0 w-full h-full object-cover ken-burns"
      />
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(15,15,30,.75) 0%, rgba(15,15,30,.55) 50%, rgba(15,15,30,.9) 100%)',
        }}
      />
      <ScrollReveal className="relative z-10 max-w-5xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-3 mb-6">
          <span className="h-[2px] w-12 bg-thunder" />
          <span className="text-thunder font-display tracking-[0.4em] text-xs">// READY?</span>
          <span className="h-[2px] w-12 bg-thunder" />
        </div>

        <h2 className="font-display font-bold text-white leading-[0.88] mb-8">
          <span className="block text-4xl sm:text-6xl md:text-7xl lg:text-9xl">GET YOUR</span>
          <span className="block text-5xl sm:text-7xl md:text-8xl lg:text-[10rem] text-thunder">FREE QUOTE</span>
        </h2>

        <p className="text-white/80 text-lg sm:text-xl max-w-2xl mx-auto mb-12">
          Free estimates. Transparent pricing. Crews that show up on time and leave your space better than they found it.
        </p>

        <div className="flex flex-col sm:flex-row gap-5 justify-center">
          <button
            onClick={handleQuoteClick}
            className="pulse-btn bg-electric hover:bg-electric-bright text-charcoal-deep font-display font-bold px-6 sm:px-12 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] transition glow-electric w-full sm:w-auto"
          >
            START MY QUOTE →
          </button>
          <Link
            to="/contact#schedule"
            className="bg-thunder hover:bg-thunder-dark text-charcoal-deep font-display font-bold px-6 sm:px-12 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] transition text-center w-full sm:w-auto"
          >
            SCHEDULE A CLEANING
          </Link>
          <a
            href="tel:4074616039"
            className="border-2 border-thunder text-thunder hover:bg-thunder hover:text-charcoal-deep font-display font-bold px-6 sm:px-12 py-4 sm:py-5 text-xs sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] transition text-center w-full sm:w-auto"
          >
            CALL NOW
          </a>
        </div>
      </ScrollReveal>
    </section>
  );
}
